// Alias
import Menu from '../private/menu';
export default Menu;
//# sourceMappingURL=index.js.map